import { useEffect } from 'react';
import { Container, Schedule } from '@/components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { isAuthenticated } from '@/utils/auth';
import { PagesPaths } from '@/enums';
import styles from './PublicHome.module.scss';

const PublicHome = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated()) {
      navigate(PagesPaths.Schedule, { replace: true });
    }
  }, [navigate]);

  const { t } = useTranslation('schedule');

  return (
    <Container title={t('title')} className={styles.publicHome}>
      <Schedule />
    </Container>
  );
};

export default PublicHome;
